/** Máximo de fotos do trabalho por perfil (guia / terapeuta). */
export const MAX_FOTOS_TRABALHO_FORNECEDOR = 4;

export function normalizeFotosTrabalhoFornecedor(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  return raw.map((x) => String(x ?? '').trim()).filter(Boolean).slice(0, MAX_FOTOS_TRABALHO_FORNECEDOR);
}
